export default __webpack_public_path__ + "static/media/productList3.84e4930b.png";